import Select from 'component/atom/forms/select/select/Select';
import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import styles from './RedirectForm.module.scss';
import { workflow } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
const RedirectForm = () => {
  const formik = useFormikContext();
  const { workflowData } = useWorkflowContext();
  const {
    data: dataOptions,
    isFetching,
    refetch: refetchData,
  } = useFetch(
    ['workflowData'],
    workflow.getAllWorkflowsPaged,
    {
      enabled: !!workflowData?.botId,
    },
    {
      pageSize: 100,
      pageNumber: 1,
      botId: workflowData?.botId,
    }
  );
  useEffect(() => {
    refetchData();
  }, [workflowData?.botId]);

  useEffect(() => {
    formik.setFieldValue(
      'workflowName',
      dataOptions?.data?.items?.find(
        (i) => i.id === formik.values.redirectWorkflowId
      )?.name
    );
  }, [formik.values.redirectWorkflowId]);
  
  return (
    <form
      className="formCont"
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <Select
        placeholder="Select Workflow"
        name="redirectWorkflowId"
        options={dataOptions?.data?.items?.map((i) => ({
          value: i.id,
          label: i.name,
        }))}
        value={formik.values.redirectWorkflowId}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.redirectWorkflowId}
        touched={formik.touched.redirectWorkflowId}
        isLoading={isFetching}
      />
      <div className={styles.border}></div>
    </form>
  );
};

export default RedirectForm;
